import React from 'react';

const ChevronLeftIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" strokeWidth={1.5} stroke="currentColor" {...props}>
    <polyline points="15 18 9 12 15 6"></polyline>
  </svg>
);

export default ChevronLeftIcon;